import { statusLabel } from '../utils/labels';

const COLOR_MAP: Record<string, string> = {
  // 工单
  open: 'orangered',
  processing: 'gold',
  resolved: 'green',
  closed: 'gray',
  completed: 'green',
  // 坐席状态
  idle: 'green',
  break: 'orange',
  offline: 'gray',
  busy: 'red',
  talking: 'red',
  after_work: 'gold',
  ringing: 'arcoblue',
  acw: 'gold',
  after_call_work: 'gold',
  // 呼叫
  answered: 'green',
  missed: 'red',
  failed: 'red',
  voicemail: 'gray',
  // 方向
  inbound: 'arcoblue',
  outbound: 'purple',
  // 会话
  queued: 'orange',
  robot: 'purple',
  human: 'arcoblue',
  finished: 'green',
  // 外呼任务
  draft: 'gray',
  // 「待处理」= orange 是全站规则（与 workflow-kb-state 各表、kb 质量工单同色）；此前为 gray
  pending: 'orange',
  running: 'arcoblue',
  paused: 'orange',
  done: 'green',
  skipped: 'gray',
  // 队列状态
  normal: 'green',
  overflow: 'gold',
  full: 'red',
  // 优先级
  low: 'gray',
  medium: 'gold',
  high: 'red',
  urgent: 'red',
  // 通用
  enabled: 'green',
  disabled: 'gray',
  synced: 'green',
  success: 'green',
  waiting: 'gray',
  calling: 'arcoblue',
  connected: 'green',
  no_answer: 'gold',
  blacklisted: 'purple',
  // 角色
  supervisor: 'purple',
  // 审计日志动作（W5-3）
  login: 'green',
  login_failed: 'red',
  create: 'arcoblue',
  update: 'gold',
  delete: 'red',
  export: 'purple',
  reset_password: 'orange',
  claim: 'arcoblue',
  transfer: 'purple',
  sync: 'green',
  // 质检违规点复核结论（human_status）
  UNVERIFIED: 'gold',
  VERIFIED: 'green',
  MISJUDGED: 'red',
  CORRECTED: 'arcoblue',
  // 申诉裁定（pending 已有外呼任务定义，此处不重复）
  upheld: 'green',
  revoked: 'red',
  rescore: 'arcoblue',
  // 质检规则类型（含流程类）
  process_dwell: 'purple',
  process_coverage: 'arcoblue',
  process_keyword: 'purple',
  process_llm: 'gold',
};

// 状态标签映射已迁入集中标签层 utils/labels.ts，此处 re-export statusLabel 保持旧 import 兼容。
export { statusLabel };

/**
 * 全站状态胶囊（深空统一口径，design-spec §4）：
 * 半透明底 + 同色系文字 + 细描边（bcc-pill-* token，双主题自适应），替代 Arco 实色 Tag。
 * 色名沿用 Arco 预置（green/orange/red/gray/arcoblue/purple/gold），映射进 CSS token。
 */
export default function StatusTag({ value, text }: { value?: string; text?: React.ReactNode }) {
  if (value === undefined || value === null || value === '') return <span>-</span>;
  const color = COLOR_MAP[value] || 'blue';
  return <span className={`bcc-pill bcc-pill-${color}`}>{text ?? statusLabel(value)}</span>;
}
